import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, MailOutline as InviteIcon, Settings as ManageIcon, Groups as TeamsIcon, } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { EmptyState } from "../common/EmptyState";
import { EntityListCard } from "../common/EntityListCard";
import { CardFooterLink } from "../utils/CardFooterLink";
import { TeamAvatar } from "../teams/TeamAvatar";
export const LeagueTeamsCard = ({ teams, leagueId, canModify = false, linkable = true, }) => {
    const maxTeamsToShow = 6;
    const showViewAllLink = teams.length > maxTeamsToShow;
    const teamsToDisplay = [...teams]
        .sort((a, b) => a.team.name.localeCompare(b.team.name))
        .slice(0, maxTeamsToShow);
    return (_jsx(EntityListCard, { heading: "Teams", count: teams.length, headerAction: canModify && (_jsxs(Stack, { direction: "row", spacing: 0.5, children: [_jsx(IconButton, { role: "button", component: Link, to: `/leagues/${leagueId}/invitations/`, size: "small", title: "Invite team", sx: {
                        color: "primary.main",
                        "&:hover": {
                            backgroundColor: "rgba(25, 118, 210, 0.1)",
                            transform: "scale(1.05)",
                        },
                        transition: "all 0.2s ease",
                    }, children: _jsx(InviteIcon, {}) }), _jsx(IconButton, { role: "button", component: Link, to: `/leagues/${leagueId}/teams/manage/`, size: "small", title: "Manage teams", sx: {
                        color: "text.secondary",
                        "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                            transform: "scale(1.05)",
                        },
                        transition: "all 0.2s ease",
                    }, children: _jsx(ManageIcon, {}) }), _jsx(IconButton, { role: "button", component: Link, to: `/leagues/${leagueId}/teams/add/`, size: "small", title: "Add teams", sx: {
                        color: "primary.main",
                        "&:hover": {
                            backgroundColor: "rgba(25, 118, 210, 0.1)",
                            transform: "scale(1.05)",
                        },
                        transition: "all 0.2s ease",
                    }, children: _jsx(AddIcon, {}) })] })), items: teamsToDisplay, renderRow: (membership, index, items) => {
            const content = (_jsx(Box, { sx: {
                    p: 2.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    ...(linkable && {
                        "&:hover": {
                            backgroundColor: "#f8f9ff",
                            transform: "translateX(2px)",
                        },
                    }),
                    transition: "all 0.2s ease",
                    borderBottom: index < items.length - 1
                        ? "1px solid rgba(0,0,0,0.08)"
                        : "none",
                }, children: _jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [_jsx(TeamAvatar, { team: membership.team }), _jsxs(Box, { sx: { ml: 2 }, children: [_jsx(Typography, { variant: "body1", sx: { fontWeight: 600, mb: 0.5 }, children: membership.team.name }), membership.team.nickname && (_jsx(Typography, { "test-id": "nickname", variant: "caption", sx: {
                                        color: "text.secondary",
                                        fontStyle: "italic",
                                        display: "block",
                                    }, children: membership.team.nickname })), _jsxs(Typography, { variant: "caption", sx: { color: "text.secondary", display: "block" }, children: ["Joined ", format(new Date(membership.dateJoined), "yyyy")] })] })] }) }, linkable ? undefined : membership.id));
            return linkable ? (_jsx(Link, { to: `/teams/${membership.team.id}/`, style: { textDecoration: "none", color: "inherit" }, children: content }, membership.id)) : (content);
        }, emptyState: _jsx(EmptyState, { icon: _jsx(TeamsIcon, {}), heading: "No teams yet", description: "Add teams to get started", actionVariant: "icon", actionIcon: canModify ? _jsx(AddIcon, {}) : undefined, actionLabel: canModify ? "Add team" : undefined, actionTo: canModify ? `/leagues/${leagueId}/teams/add/` : undefined }), footer: linkable &&
            showViewAllLink && (_jsx(CardFooterLink, { to: `/leagues/${leagueId}/teams/`, label: `View all ${teams.length} teams →` })) }));
};
